import $ from 'jquery';
import 'slick-carousel'

window.jQuery = window.$ = $;

export default {
  init: function() {
    /**
     * Horizontal image reel element, using jQuery.slick
     */
    $('.reel').each(function(){
      var settings = {
        slidesToShow: 1,
        mobileFirst: true,
        //cssEase: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
        //cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
        speed: 600,
        responsive: [],
        edgeFriction: 0,
        touchTreshold: 3,
        rows: 0 // Fix vor v1.8.0-1
      };

      /**
       * TODO: Find a way to get Foundation SCSS breakpoint pixel values,
       * instead of hard-coding them here.
       *
       * HINT: if(isBreakpoint('small-only')) (see line 260-ish)
       */
      if($(this).attr('data-medium')){
        settings.responsive.push({
          breakpoint: 642,
          settings: {
            slidesToShow: parseInt($(this).attr('data-medium'))
          }
        });
      }
      if($(this).attr('data-large')){
        settings.responsive.push({
          breakpoint: 1026,
          settings: {
            slidesToShow: parseInt($(this).attr('data-large'))
          }
        });
      }
      if($(this).attr('data-xlarge')){
        settings.responsive.push({
          breakpoint: 1600,
          settings: {
            slidesToShow: parseInt($(this).attr('data-xlarge'))
          }
        });
      }
      $(this).slick(settings);
    });
  }
};
